export default __webpack_public_path__ + "static/media/app_store.b610de71.svg";